import * as React from "react";
import { SVGProps } from "react";
const SvgVideoReplay = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16 3c7.168 0 13 5.832 13 13s-5.832 13-13 13S3 23.168 3 16c0-2.825.902-5.525 2.566-7.757-1.091.293-2.16.678-3.464 1.19A1 1 0 0 1 1.37 7.57c1.996-.783 3.862-1.46 6.5-1.82.509-.061.98.252 1.105.745.657 2.583.727 4.567.748 6.709a1 1 0 0 1-.99 1.01h-.01a1 1 0 0 1-1-.99c-.017-1.609-.07-2.867-.263-4.158A10.937 10.937 0 0 0 5 16c0 6.065 4.935 11 11 11s11-4.935 11-11S22.065 5 16 5V3Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgVideoReplay;
